import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogImage?: string;
  ogType?: string;
  keywords?: string;
}

const SEO: React.FC<SEOProps> = ({
  title = 'Open Hope Initiative Nigeria - National Emergency Response Platform',
  description = 'Preparing to launch a national toll-free USSD emergency grid connecting every Nigerian to rapid response. Protecting citizens, empowering communities.',
  canonical,
  ogImage = 'https://res.cloudinary.com/ddf1wv47y/image/upload/v1742485745/Open_Hope_gwfcli.png',
  ogType = 'website',
  keywords = 'emergency response Nigeria, USSD emergency grid, farmer security, community safety, NEMA, disaster response, agricultural security, rural safety'
}) => {
  const fullTitle = title.includes('Open Hope Initiative') ? title : `${title} | Open Hope Initiative Nigeria`;
  const siteUrl = canonical || 'https://openhopeinitiative.com';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="Open Hope Initiative" />
      <meta property="og:locale" content="en_NG" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:site" content="@openhopeNG" />
      <meta name="twitter:creator" content="@openhopeNG" />
      
      {/* Additional Meta Tags */}
      <meta name="author" content="Open Hope Initiative" />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      <meta name="geo.region" content="NG" />
      <meta name="geo.placename" content="Nigeria" />
    </Helmet>
  );
};

export default SEO;